import Vuex from 'vuex';
import Vue from 'vue';
import baseStore from '@/modules/index.module';
import option from '@/modules/option.module';
import tenant from '@/modules/tenant.module';

Vue.use(Vuex);

export default new Vuex.Store({
	...baseStore,
	modules: {
		option,
		tenant,
	},
});
